var map = {
	"./": 2,
	"./en": 452,
	"./en.json": 452,
	"./en.white-label": 453,
	"./en.white-label.json": 453,
	"./fa": 454,
	"./fa.json": 454,
	"./fa.white-label": 455,
	"./fa.white-label.json": 455,
	"./index": 2,
	"./index.js": 2,
	"./ko": 456,
	"./ko.json": 456,
	"./ko.white-label": 457,
	"./ko.white-label.json": 457,
	"./useLocale": 421,
	"./useLocale.js": 421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 686;